<template>
  <div class="petinfo">
    <header-top :goBack="true" @editpet="editpet" :isedit="true" v-show="!ifedit" :mine='true'></header-top>
    <header-top :isshow="true" v-show="ifedit" @back="back" :mine='true'></header-top>
    <div class="title" ref="title">
      <p class="addtext">{{$t('addpet.petNews')}}</p>
    </div>
    <div class="petinfo-main" ref="wrapper">
      <div style="height: 750px;">
        <div class="head_img" v-show="!ifedit">
          <img :src="portrait" style="margin: auto;display: block;">
          <p class="setimg">{{petname}}</p>
        </div>
        <div class="head_img" v-show="ifedit">
          <img
            :src="imgflag?avatar:avatar1"
            @click.stop="uploadHeadImg"
            style="margin: auto;display: block;"
            v-show="isshow"
          >
          <canvas
            ref="can"
            v-show="showflag1"
            style="width:80px;height:80px;margin: auto;display: block;border-radius: 50%;"
            @click.stop="uploadHeadImg"
          ></canvas>
          <input type="file" accept="image/*" @change="handleFile" class="hiddenInput">
          <p class="setimg">{{petname}}</p>
        </div>
        <div class="pet">
          <ul>
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/petNick.png" alt="">{{$t('addpet.petName')}}</span>
              <p class="infoBox" v-show="!ifedit">{{petname}}</p>
              <el-input
                :value="petname"
                @input="changename"
                @change="Verificationname"
                maxlength="12"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag6">{{$t('addpet.have')}}</span>
            </li>
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/petType.png" alt="">{{$t('addpet.petType')}}</span>
              <p v-show="!ifedit">{{petType}}</p>
              <el-input
                :value="petType"
                @input="changepetbelong"
                @change="Verificationbelong"
                maxlength="8"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag7">{{$t('addpet.have')}}</span>
            </li>
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/petColor.png" alt="">{{$t('addpet.color')}}</span>
              <p v-show="!ifedit">{{color}}</p>
              <el-input
                :value="color"
                @input="changehaircolor"
                @change="Verificationhaircolor"
                maxlength="6"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag8">{{$t('addpet.have')}}</span>
            </li>
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/sex.png" alt="">{{$t('addpet.sex')}}</span>
              <p v-show="!ifedit">{{gender}}</p>
              <div class="selectsex" v-show="ifedit">
                <el-select v-model="value" :placeholder="$t('addpet.selectSex')" @focus="issex" @visible-change="lesex" ref='sex'>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </li>
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/petWeight.png" alt="">{{$t('addpet.weight')}}(KG)</span>
              <p v-show="!ifedit">{{weight}}</p>
              <el-input :value="weight" @input="changeweight" @change="judgeweight" v-show="ifedit" type="number"></el-input>
              <span class="danger" v-show="flag1">{{$t('addpet.not')}}</span>
              <span class="danger" v-show="flag9">{{$t('addpet.have')}}</span>
            </li>
            <!-- <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/sex.png" alt="">{{$t('addpet.height')}}(CM)</span>
              <p v-show="!ifedit">{{height}}</p>
              <el-input :value="height" @input="changeheight" @change="judgeheight" v-show="ifedit" type="number"></el-input>
              <span class="danger" v-show="flag">{{$t('addpet.not')}}</span>
              <span class="danger" v-show="flag10">{{$t('addpet.have')}}</span>
            </li> -->
            <li>
              <span class="petNewsIcon"><img src="../../../static/img/account2/petBirth.png" alt="">{{$t('addpet.birthday')}}</span>
              <p v-show="!ifedit">{{birthTime}}</p>
              <div class="block" v-show="ifedit">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="birthTime"
                  :picker-options="pickerOptions"
                  @focus="disapper"
                  ref="datetime"
                ></el-date-picker>
              </div>
            </li>
            <!-- <li>
              <span class="petNewsIcon">{{$t('addpet.character')}}</span>
              <p v-show="!ifedit">{{character}}</p>
              <el-input
                :value="character"
                @input="changecharacter"
                @change="Verificationcharacter"
                maxlength="8"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag11">{{$t('addpet.have')}}</span>
            </li> -->
          </ul>
          <!-- <div class="pet-msg">
            <div class="petname">
              <span>{{$t('addpet.petName')}}</span>
              <p class="infoBox" v-show="!ifedit">{{petname}}</p>
              <el-input
                :value="petname"
                @input="changename"
                @change="Verificationname"
                maxlength="12"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag6">{{$t('addpet.have')}}</span>
            </div>
            <div class="petbelong">
              <span>{{$t('addpet.petType')}}</span>
              <p v-show="!ifedit">{{petType}}</p>
              <el-input
                :value="petType"
                @input="changepetbelong"
                @change="Verificationbelong"
                maxlength="8"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag7">{{$t('addpet.have')}}</span>
            </div>
          </div> -->
          <!-- <div class="pet-msg">
            <div class="haircolor">
              <span>{{$t('addpet.color')}}</span>
              <p v-show="!ifedit">{{color}}</p>
              <el-input
                :value="color"
                @input="changehaircolor"
                @change="Verificationhaircolor"
                maxlength="6"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag8">{{$t('addpet.have')}}</span>
            </div>
            <div class="sex">
              <span>{{$t('addpet.sex')}}</span>
              <p v-show="!ifedit">{{gender}}</p>
              <div class="selectsex" v-show="ifedit">
                <el-select v-model="value" :placeholder="$t('addpet.selectSex')" @focus="issex" @visible-change="lesex" ref='sex'>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div> -->
          <!-- <div class="pet-msg">
            <div class="weight">
              <span>{{$t('addpet.weight')}}(KG)</span>
              <p v-show="!ifedit">{{weight}}</p>
              <el-input :value="weight" @input="changeweight" @change="judgeweight" v-show="ifedit" type="number"></el-input>
              <span class="danger" v-show="flag1">{{$t('addpet.not')}}</span>
              <span class="danger" v-show="flag9">{{$t('addpet.have')}}</span>
            </div>
            <div class="height">
              <span>{{$t('addpet.height')}}(CM)</span>
              <p v-show="!ifedit">{{height}}</p>
              <el-input :value="height" @input="changeheight" @change="judgeheight" v-show="ifedit" type="number"></el-input>
              <span class="danger" v-show="flag">{{$t('addpet.not')}}</span>
              <span class="danger" v-show="flag10">{{$t('addpet.have')}}</span>
            </div>
          </div> -->
          <!-- <div class="pet-msg">
            <div class="birthday">
              <span>{{$t('addpet.birthday')}}</span>
              <p v-show="!ifedit">{{birthTime}}</p>
              <div class="block" v-show="ifedit">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="birthTime"
                  :picker-options="pickerOptions"
                  @focus="disapper"
                  ref="datetime"
                ></el-date-picker>
              </div>
            </div>
            <div class="character">
              <span>{{$t('addpet.character')}}</span>
              <p v-show="!ifedit">{{character}}</p>
              <el-input
                :value="character"
                @input="changecharacter"
                @change="Verificationcharacter"
                maxlength="8"
                v-show="ifedit"
              ></el-input>
              <span class="danger" v-show="flag11">{{$t('addpet.have')}}</span>
            </div>
          </div> -->
          <div class="save-btn" style="margin: 20px 0;">
            <el-button
              type="primary"
              style="margin:15px auto;display: block;width: 80%;"
              @click="search"
              v-show="!ifedit"
            >{{$t('addpet.report')}}</el-button>
            <!-- <div class="btn" @click="remove" v-show="!ifedit">{{$t('addpet.deletePet')}}</div> -->
            <el-button
              type="primary"
              style="margin:15px auto;display: block;width: 80%;"
              @click="remove"
              v-show="!ifedit"
            >{{$t('addpet.deletePet')}}</el-button>
            <el-button
              type="primary"
              style="margin: auto;display: block;width: 80%;"
              @click="save"
              v-show="ifedit"
            >{{$t('addpet.savechage')}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import axios from "axios";
import EXIF from "exif-js/exif.js";
import headerTop from "../../components/header";
import Qs from "qs";
import {
  deletepet,
  getPetDevices,
  updatePet
} from "../../ClientServerApi/index.js";
import { getLoginUser } from "../../api/index.js";
export default {
  name: "petinfo",
  inject: ["reload"],//父组件中通过provider来提供变量，子组件通过inject注入变量
  data() {
    return {
      petlist: "",
      petname: "",
      petType: "",
      birthTime: "",
      color: "",
      gender: "",
      weight: "",
      height: "",
      character: "",
      portrait: "",
      portrait1: "",
      id: "",
      num: "1",
      imgflag: false,
      showflag: false,
      showflag1: false,
      isshow: true,
      avatar: "",
      avatar1: "",
      num: "1",
      value: "",
      Height: "",
      options: [
        {
          value: this.$t("prompt.boy"),
          label: this.$t("prompt.boy")
        },
        {
          value: this.$t("prompt.girl"),
          label: this.$t("prompt.girl")
        }
      ],
      flag: false,
      flag1: false,
      flag6: false,
      flag7: false,
      flag8: false,
      flag9: false,
      flag10: false,
      flag11: false,
      scrollY:0,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      ifedit: false
    };
  },
  components: {
    headerTop
  },
  created() {
    this.petname = this.$route.query.petname;
    this.petType = this.$route.query.pettype;
    this.color = this.$route.query.haircolor;
    this.gender = this.$route.query.sex;
    this.value = this.$route.query.sex;
    this.weight = this.$route.query.weight;
    this.height = this.$route.query.height;
    this.birthTime = this.$route.query.birthTime.slice(0, 10);
    this.character = this.$route.query.character;
    this.portrait = this.$route.query.src;
    this.avatar1 = this.$route.query.src;
    this.id = this.$route.query.id;
    this.Height =
      document.documentElement.clientHeight || document.body.clientHeight;
    //检验是否登录超时
    if (sessionStorage.getItem("login") == 1) {
      getLoginUser()
        .then(res => {
          if (res.data.header.status == 3019) {
            sessionStorage.setItem("login", "1");
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.$nextTick(() => {
      this._initScroll()
      this.$refs.wrapper.style.height = this.Height - 65 + "px";
      this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + 40 + "px";
    });
  },
  methods: {
     _initScroll(){
            this.Scroll = new IScroll(this.$refs.wrapper, {
                click: true,
                probeType: 3
            });
            let self = this
            this.Scroll.on('scroll',function(){
                self.scrollY = this.y
            },true)
        },
    // 打开图片上传
    uploadHeadImg: function() {
        this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile: function(e) {
      var th = this;
      th.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      th.changeflag = true;
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag1 = false;
          th.isshow = true;
          th.avatar = res.result;
          th.portrait1 = data.target.result.split(",")[1];
        } else {
          th.compress(res.result, Orientation);
        }
      };
    },
    compress(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag1 = true;
      th.isshow = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        var canvas = th.$refs.can;
        var ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 0.15);
        th.portrait1 = base64.split(",")[1];
        th.avatar = base64.result;
      };
    },
    back(){
        this.ifedit = false
        this.reload()
    },
    //跳转到修改宠物
    editpet() {
      this.ifedit = true;
    },
    //发布协寻跳转
    search() {
      let params = Qs.stringify({ petId: this.id });
      getPetDevices(params)
        .then(res => {
          // console.log(res);
          if (res.data.header.status == 80002) {
            this.$message({
              type: "error",
              message: this.$t("prompt.notdevice")
            });
          } else {
            this.$router.push({
              path: "/releaseSearch",
              query: { portrait: this.portrait, petId: this.id }
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + 40 + "px";
    },
    //验证宠物名称
    Verificationname() {
      if (this.petname.length > 0) {
        this.flag6 = false;
      }
    },
    //验证宠物品种
    Verificationbelong() {
      if (this.petType.length > 0) {
        this.flag7 = false;
      }
    },
    //验证宠物毛色
    Verificationhaircolor() {
      if (this.color.length > 0) {
        this.flag8 = false;
      }
    },
    //验证宠物性格
    // Verificationcharacter() {
    //   if (this.character.length > 0) {
    //     this.flag11 = false;
    //   }
    // },
    //验证宠物身高
    // judgeheight() {
    //   let reg = /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/;
    //   if (reg.test(this.height)) {
    //     this.flag = false;
    //   } else {
    //     this.flag = true;
    //   }
    //   if (this.height.length > 0) {
    //     this.flag10 = false;
    //   }
    // },
    //验证宠物体重
    judgeweight() {
      let reg = /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/;
      if (reg.test(this.weight)) {
        this.flag1 = false;
      } else {
        this.flag1 = true;
      }
      if (this.weight.length > 0) {
        this.flag9 = false;
      }
    },
    issex(){
       this.Scroll.destroy()
        },
    lesex(e){
      if(e==false){
            this._initScroll()
            this.Scroll.refresh()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.sex.blur()
          }
        },
    disapper() {
      this.$refs.datetime.blur();
    },
    //修改宠物
    save() {
      if (this.petname.length == 0) {
        this.flag6 = true;
      }
      if (this.petType.length == 0) {
        this.flag7 = true;
      }
      if (this.color.length == 0) {
        this.flag8 = true;
      }
      if (this.weight.length == 0) {
        this.flag9 = true;
      }
      // if (this.height.length == 0) {
      //   this.flag10 = true;
      // }
      // if (this.character.length == 0) {
      //   this.flag11 = true;
      // }
      // this.judgeheight()
      this.judgeweight()
      if (
        this.flag == false &&
        this.flag1 == false &&
        this.flag6 == false &&
        this.flag7 == false &&
        this.flag8 == false &&
        this.flag9 == false &&
        this.flag10 == false &&
        this.flag11 == false
      ) {
        setTimeout(() => {
          var params = Qs.stringify({
            name: this.petname,
            petId: this.id,
            height: this.height,
            weight: this.weight,
            birthTime: this.birthTime,
            petType: this.petType,
            portrait: this.portrait1,
            color: this.color,
            gender: this.value,
            character: this.character
          });
          updatePet(params)
            .then(res => {
              // console.log(res);
              if (res.data.header.status == 1000) {
                this.ifedit = false;
                this.portrait = res.data.data.portrait;
              }
            })
            .catch(error => {
              console.log(error);
            });
        }, 200);
      }
    },
    //删除宠物
    remove() {
      this.$confirm(this.$t("prompt.delete"), this.$t("prompt.promptcancel"), {
        confirmButtonText: this.$t("prompt.sure"),
        cancelButtonText: this.$t("prompt.cancel"),
        type: "warning"
      })
        .then(() => {
          var params = Qs.stringify({
            petId: this.id
          });
          deletepet(params)
            .then(res => {
              // console.log(res);
              if (res.data.header.status == 1000) {
                this.$message({
                  type: "success",
                  message: this.$t("prompt.deletesuccess")
                });
                this.$router.push({ path: "/myAccount" });
                this.reload();
              }
              if (res.data.header.status == 81004) {
                this.$message({
                  type: "error",
                  message: this.$t("prompt.cantdelete")
                });
              }
              if (res.data.header.status == 81003) {
                this.$message({
                  type: "error",
                  message: this.$t("prompt.cantdelete")
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("prompt.canceldelete")
          });
        });
    },
    changename(e) {
      this.petname = e;
    },
    changepetbelong(e) {
      this.petType = e;
    },
    changeheight(e) {
      this.height = e;
    },
    changeweight(e) {
      this.weight = e;
    },
    changebirthday(e) {
      this.birthTime = e;
    },
    changehaircolor(e) {
      this.color = e;
    },
    changecharacter(e) {
      this.character = e;
    }
  }
};
</script>
<style>
/* .el-message {
  min-width: 50%;
}
.petinfo .el-input__icon {
  line-height: 100%;
}
.petinfo .birthday .el-input__icon {
  line-height: 100%;
  height: 0;
}
.petinfo .el-select .el-input .el-select__caret {
  color: rgb(9, 81, 150);
}
.petinfo .el-input__inner {
  color: rgb(9, 81, 150);
  border-radius: 0%;
  font-size: 0.8rem;
  height: 25px;
  line-height: 25px;
  padding: 0 3px;
  padding-bottom: 5px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-color: rgb(9, 81, 150);
}
.el-message-box {
  width: 300px;
}
.petinfo .el-button--primary {
  background-color: rgb(9, 81, 150);
  border-color: rgb(9, 81, 150);
}
.petinfo .el-input--prefix .el-input__inner {
  padding-left: 22px;
}
.petinfo .el-input__prefix {
  left: 0;
}
.petinfo .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.petinfo .el-select:hover .el-input__inner{
  border-color: rgb(9, 81, 150);
} */
.pet .el-input__inner{
  border: 0;
  width: 100%;
  box-sizing: border-box;
  text-align: right;
  border-bottom: 1px solid #eaeef9;
  height: 3.2rem;
  line-height: 3.2rem;
  padding: 0 0.5rem 0 8rem;
  font-size: 0.8rem;
}
.pet .el-select,.pet .el-input{
  width: 100%;
}
.save-btn .el-button--primary{
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
</style>
<style scoped>
@media screen and (max-width: 321px) {
    .pet span{
        font-size: 0.78rem !important;
    }
}
.btn {
  color: #fff;
  background-color: rgb(9, 81, 150);
  border-color: rgb(9, 81, 150);
  width: 80%;
  margin: 0 auto;
  border: 0;
  height: 38px;
  display: block;
  margin-bottom: 20px;
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
  line-height: 38px;
}
.edit {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 20%;
  right: 10px;
}
/* .pet p {
  padding: 0 3px;
  color: rgb(18, 87, 157);
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  padding-bottom: 5px;
  font-size: 0.8rem;
  height:25px;
  box-sizing:border-box;
} */
.addtext {
  text-align: center;
  padding-top: 5px;
  font-size: 0.8rem;
  color: rgb(130, 130, 130);
}
.head_img {
  margin-top: 20px;
}
.head_img img {
  width: 5.625rem;
  height: 5.625rem  ;
  border-radius: 50%;
}
.setimg {
  text-align: center;
  font-size: 0.8rem;
  margin-top: 10px;
}
.hiddenInput {
  display: none;
}
.petinfo {
  width: 100%;
}
.petinfo .danger {
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}
.petinfo-main {
  position: absolute;
  top: 55px;
  bottom: 0;
  width: 100%;
  max-width: 579px;
  overflow: hidden;
  touch-action: none;
}
/* .petname {
  flex: 1;
  margin-left: 15px;
  margin-top: 40px;
} */
.pet {
  width: 100%;
}
.pet ul{
  border-top: 1px solid #eaeef9;
  margin-top: 2rem;
}
.pet ul li{
  list-style: none;
  width: 100%;
  position: relative;
}
.petNewsIcon{
  position: absolute;
  width: 7rem;
  font-size: 0.8rem;
  display: block;
  height: 3.2rem;
  line-height: 3.2rem;
  z-index: 999;
}
.petNewsIcon img{
  width: 1.2rem;
  vertical-align: middle;
  margin: 0 0.5rem;
}
.pet ul li p{
  width: 100%;
  box-sizing: border-box;
  text-align: right;
  border-bottom: 1px solid #eaeef9;
  height: 3.2rem;
  line-height: 3.2rem;
  padding: 0 0.5rem 0 8rem;
  font-size: 0.8rem;
}
/* .pet span {
    font-size: 0.8rem;
    margin-bottom: 5px;
    margin-left: 3px;
    display: block;
}
.petbelong {
  flex: 1;
  margin-top: 40px;
  margin-right: 15px;
  margin-left: 40px;
}
.haircolor {
  flex: 1;
  margin-left: 15px;
  margin-top: 40px;
}
.pet-msg {
  display: flex;
}
.sex {
  flex: 1;
  margin-top: 40px;
  margin-right: 15px;
  margin-left: 40px;
}
.height {
  flex: 1;
  margin-top: 40px;
  margin-right: 15px;
  margin-left: 40px;
}
.weight {
  flex: 1;
  margin-left: 15px;
  margin-top: 40px;
}
.birthday {
  flex: 1;
  margin-left: 15px;
  margin-top: 40px;
}
.character {
  flex: 1;
  margin-top: 40px;
  margin-right: 15px;
  margin-left: 40px;
} */
</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/petinfo.vue